import { ref } from 'vue';
import { createApolloClient } from '@/components/commons/apollo.js';
import useEventHook from './useEventHook.js';

/**
 * Execute a query operation to fetch data from the GraphQL API endpoint.
 * @param {string} query GraphQL query to be executed
 * @param {object} variables The values of the variables used in the query
 * @param {object} options Additional query options, like caching and fetching policy
 */
export default function useQuery(query, variables = {}, overrideOptions = {}) {
  const loading = ref(false);
  const error = ref(null);
  const result = ref(null);

  const resultEvent = useEventHook();
  const errorEvent = useEventHook();

  const currentOptions = {};

  const apolloClient = createApolloClient(import.meta.env.SSR);

  async function start() {
    try {
      loading.value = true;
      const queryResult = await apolloClient.query({
        query,
        variables,
        ...currentOptions,
        ...overrideOptions,
      });
      logger.trace({
        msg: 'apollo query',
        query: query.definitions?.map((d) => d.name.value),
        variables,
        networkStatus: queryResult.networkStatus,
      });
      loading.value = queryResult?.loading;
      result.value = queryResult?.data;
      resultEvent.trigger(queryResult?.data);
    } catch (e) {
      error.value = e;
      loading.value = false;
      errorEvent.trigger(e);
      throw e;
    }
  }

  start();

  return {
    loading,
    result,
    error,
    onResult: resultEvent.on,
    onError: errorEvent.on,
  };
}
